import React from 'react';
import PropTypes from 'prop-types';
import hasGrade from '$utils/hasGrade';

import GradeInput from '../GradeInput';

const FreeForm = ({ onBlur, onChange, grade, error }) => {
  const handleChange = ({ target: { value } }) => {
    // support empty value to unset a grade
    if (value.trim() === '') {
      onChange();
      return;
    }

    if (hasGrade({ displayGrade: value })) {
      onChange(value);
    }
  };

  return (
    <GradeInput
      onBlur={onBlur}
      onChange={handleChange}
      grade={grade}
      label="freeform grade input"
      error={error}
    />
  );
};

FreeForm.propTypes = {
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  grade: PropTypes.string,
  error: PropTypes.bool,
};

FreeForm.defaultProps = {
  grade: '',
  error: false,
};

export default FreeForm;
